(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SectorTypeSearch', SectorTypeSearch);

    SectorTypeSearch.$inject = ['$resource'];

    function SectorTypeSearch($resource) {
        var resourceUrl =  'api/_search/sector-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
